/**
 * Created by Administrador on 15/05/2017.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {
        $stateProvider
            .state('itineraryListRevenue', {
                parent: 'app',
                url: '/revenuePlaning/itineraryList',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/configGeneral/rates/revenue/revenuePlanning/itineraries.html',
                        controller: 'itineraryListRevenueCtrl',
                        controllerAs: 'vm',
                        'resolve' : {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['itinerary']);
                            }],
                            'itineraries' : ['itineraryService',
                                function(itineraryService){
                                    return itineraryService.getAllItineraries();
                                }],
                            'tabRevenue': ['tabService', function(tabService){
                                return tabService.getTabRevenue('itineraryListRevenue')
                            }]
                        }
                    }
                }
            })
    }
})();


